import React from "react"
import { Link } from 'react-router-dom'
import { Row, Col, Card, Tabs, Button, Table, Spin } from 'antd';
import { Scrollbars } from 'react-custom-scrollbars';
import ReactEcharts from 'echarts-for-react';
import 'echarts/lib/chart/gauge';
import numeral from 'numeral'

import styles from './index.css';
import PropTypes from 'prop-types'

import step_right_arrow from '../../styles/images/right.png'
import step_left_arrow from '../../styles/images/left.png'
import step_down_arrow from '../../styles/images/down.png'
import NHFetch from "../../utils/NHFetch"
import getSize from "../../utils/getSize";
import { createUuid, getLoginUser } from "../../utils/NHCore"

const basicUrl = '/yxxc/'; //基础请求路径

import jianbian from '../../styles/images/jianbian.jpg';

//加载所有环节图片——正常状态
const userImg = require.context("../../styles/images/user/normal", true, /(\.gif|\.jpeg|\.png|\.jpg|\.bmp)/);
//加载所有环节图片——不可用状态
const userImg_grey = require.context("../../styles/images/user/grey", true, /(\.gif|\.jpeg|\.png|\.jpg|\.bmp)/);
//缓存图片
const imgData = userImg.keys().map(userImg);
const imgArray = userImg.keys().map((imgName, key) => {
    return { name: imgName, data: imgData[key] }
});
const imgData_grey = userImg_grey.keys().map(userImg_grey);
const imgArray_grey = userImg_grey.keys().map((imgName, key) => {
    return { name: imgName, data: imgData_grey[key] }
});

const TabPane = Tabs.TabPane;


export default class Process extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            rem: 100,
            lcid: '0', //当前流程ID
            lcrs: 0, //流程应到人数
            defaultTab: '0', //默认显示流程
            gaugeData: {}, //仪表图统计数据
            tableData: [], //即时统计数据
            lcpzData: [], //流程配置数据
            loading: false, //是否正在加载流程
            gaugeImgLoadUp: false, //仪表图背景是否加载完成
        }
    }

    //加载统计数据
    componentDidMount() {

        // 表示1920的设计图,使用100PX的默认值
        const whdef = 100 / 1920;
        // 当前窗口的宽度
        const wW = window.innerWidth;
        // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
        const rem = parseInt(wW * whdef);

        this.setState({ rem });

        //加载流程配置数据
        this.loadLcpz((lcid, dqlcpz) => {
            //加载饼图统计数据
            this.loadPieStatisticalData(lcid);
            //加载即时统计数据
            this.loadTableStatisticalData(lcid);

            //加载流程后，将当前流程配置信息传递给父组件
            const onLoad = this.props.onLoad;
            if (onLoad) {
                onLoad(lcid, dqlcpz, this.state.lcpzData);
            }
        });
    }

    //根据流程ID获取饼图统计数据
    loadPieStatisticalData = (lcid) => {
       if(lcid){
        NHFetch(basicUrl + 'getPieStatisticalData', 'GET', { lcid: lcid })
        .then(res => {
            if (res) {
                let data = res.data;
                if (data) {
                    let gaugeData = { name: '报到率', bdrs: data.bdrs ? data.bdrs : 0, zrs: data.zrs ? data.zrs : 0 };
                    this.setState({ gaugeData: gaugeData });
                } else {
                    this.setState({ gaugeData: {} });
                }
            }
        });

       }

    }

    //获取即时统计数据
    loadTableStatisticalData = (lcid) => {
        if(lcid){
            NHFetch(basicUrl + 'getTableStatisticalData', 'GET', { lcid: lcid })
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        let lcrs = 0;
                        for (let key in data) {
                            lcrs = data[key].lcrs ? data[key].lcrs : 0;
                            break;
                        }
                        this.setState({ lcrs: lcrs, tableData: data });
                    } else {
                        this.setState({ tableData: [] });
                    }
                }
            });
        }
    }

    //获取当前年度启用的流程配置信息
    loadLcpz = (callback) => {
        let userId = getLoginUser() ? getLoginUser().userId : '';
        this.setState({ loading: true });
        NHFetch(basicUrl + 'getLcpz', 'GET', { yhid: userId })
            .then(res => {
                this.setState({ loading: false });
                if (res) {
                    let data = res.data;
                    if (data && data.length > 0) {
                        let lcid = data[0].lcdyVO.pkid;
                        //设置默认展示页面，当前流程ID
                        this.setState({ lcid: lcid, defaultTab: lcid, lcpzData: data });
                        callback(lcid, data[0]);
                    } else {
                        this.setState({ lcpzData: [] });
                        callback(null);
                    }
                }
            }).catch(err => this.setState({ loading: false }));
    }

    //生成仪表图构造参数
    getGaugeOption = () => {

        if (this.echartCore) {
            let echartInstance = this.echartCore.getEchartsInstance();
            echartInstance.resize();
        }

        const { rem, gaugeData } = this.state;

        //为了防止除数为0报错，此时默认为1
        let { name = '', bdrs = 0, zrs = 0 } = gaugeData;
        let percent = 0;
        let total = !zrs || zrs == 0 ? 1 : zrs;

        percent = bdrs / total * 100;

        let offsetAngle = -35;
        let totalAngle = 250; //仪表盘角度差值
        let startAngle = totalAngle + offsetAngle;
        let endAngle = startAngle - Math.floor(bdrs / total * totalAngle);

        let series_sn_1 = 1;
        let series_sn_2 = 1;

        if (Math.floor(bdrs / total * 100) == 0) {
            series_sn_1 = 0;
        }

        if ((100 - Math.floor(bdrs / total * 100)) == 0) {
            series_sn_2 = 0;
        }

        let myCanvas = document.getElementById('myCanvas');
        if (myCanvas) {
            if (this.echartCore) {
                //获取仪表图的宽高，并设置到画布上
                let echartInstance = this.echartCore.getEchartsInstance();
                let echartWidth = echartInstance.getWidth();
                let echartHeight = echartInstance.getHeight();
                myCanvas.width = echartWidth;
                myCanvas.height = echartHeight;
            }

            let ctx = myCanvas.getContext("2d");
            let bgImg = document.getElementById('gradient-color');
            if (this.state.gaugeImgLoadUp) {
                //如果渐变背景图加载完成，则将其绘制到与仪表图大小一致的画布上，
                //这样仪表图在使用此画布做为背景图时，就会出现渐变效果
                ctx.drawImage(bgImg, 0, 0, myCanvas.width, myCanvas.height);
            }

            let process_this = this;
            bgImg.onload = function () {
                //如果渐变背景图加载完成，则将其绘制到画布上
                ctx.drawImage(bgImg, 0, 0, myCanvas.width, myCanvas.height);
                process_this.setState({ gaugeImgLoadUp: true });
            }
        }

        const option = {
            series: [
                {
                    name: name,
                    type: 'gauge',
                    radius: '70%',
                    splitNumber: series_sn_1,
                    startAngle: startAngle,
                    endAngle: endAngle,
                    title: {
                        show: true,
                        fontSize: 0.14 * rem,
                        offsetCenter: [0, '-35%'],
                        color: '#999999'
                    },
                    detail: {
                        show: true,
                        color: '#666666',
                        fontSize: 0.32 * rem,
                        offsetCenter: [0, '15%'],
                        formatter: function (val) {

                            if (isNaN(val)) {
                                return '0%' + `\n{a|${bdrs}/${zrs}}`;
                            }

                            if (val == 0 || val == 100) {
                                return val + `%\n{a|${bdrs}/${zrs}}`;
                            } else {
                                return val.toFixed(2) + `%\n{a|${bdrs}/${zrs}}`;
                            }
                        },
                        rich: {
                            a: {
                                fontSize: 0.14 * rem,
                                color: '#999',
                                lineHeight: 0.4 * rem
                            }
                        }
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            opacity: 0
                        }
                    },
                    axisTick: {
                        length: 12,
                        splitNumber: Math.floor(bdrs / total * 75),
                        lineStyle: {
                            width: 3,
                            color: {
                                image: myCanvas,
                                repeat: 'repeat'
                            },
                        }
                    },
                    splitLine: {
                        show: false
                    },
                    pointer: {
                        show: false
                    },
                    data: [
                        {
                            name: name,
                            value: percent
                        }
                    ]
                },
                {
                    name: '',
                    type: 'gauge',
                    radius: '70%',
                    splitNumber: series_sn_2,
                    startAngle: endAngle,
                    endAngle: offsetAngle,
                    title: {
                        show: false
                    },
                    detail: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            opacity: 0
                        }
                    },
                    axisTick: {
                        length: 12,
                        splitNumber: 75 - Math.floor(bdrs / total * 75),
                        lineStyle: {
                            width: 3,
                            color: '#cccccc',
                        }
                    },
                    splitLine: {
                        show: false
                    },
                    pointer: {
                        show: false
                    }
                }
            ]
        };

        return option;
    }

    //生成表格统计数据
    getTable = () => {
        const { lcrs, tableData } = this.state;
        const columns = [
            {
                title: '报名环节',
                dataIndex: 'hjmc',
                key: 'hjmc',
                render: (text, record) => {
                    if (record.lchjid != '-1') {
                        return <span>{text}</span>
                    } else {
                        return <span style={{ fontWeight: 'bold' }}>{text}</span>
                    }
                }
            }, {
                title: '已办人数',
                dataIndex: 'blrs',
                key: 'blrs',
                render: (text, record) => {
                    if (record.lchjid != '-1') {
                        return <span>{text}</span>
                    } else {
                        return <span style={{ fontWeight: 'bold' }}>{text}</span>
                    }
                }
            }, {
                title: '比例',
                dataIndex: 'bl',
                key: 'bl',
                render: (text, record) => {
                    if (record.lchjid != '-1') {
                        const blrs = record.blrs ? record.blrs : 0;
                        const lcrs = record.lcrs ? record.lcrs : 1;
                        return numeral(blrs / lcrs).format('0.00%');
                    } else {
                        return null;
                    }
                }
            }
        ];

        let tempData = [...tableData];

        tempData.push({ lchjid: '-1', hjmc: '应到人数', blrs: lcrs });

        return (
            <Table
                columns={columns}
                dataSource={tempData}
                rowKey={record => record.lchjid}
                pagination={false}
            />
        );

    }

    //生成流程Tab页
    getTabPanes = () => {

        const { lcpzData } = this.state;
        const tabPanes = [];

        if (lcpzData.length > 0) {

            const offset = 9; //单位偏移量
            const interval = 6; //编号间隔
            const maxCount = 5; //循环次数，最多可满足30个环节的指向

            const leftArrow = [4, 5]; //向左箭头的环节起始编号
            const rightArrow = [1, 2]; //向右箭头的环节起始编号

            let evenRowFirstCol = [4]; //偶数行第一个环节起始编号
            let evenRowLastCol = [6]; //偶数行最后一个环节或奇数行第一个环节起始编号

            let stepLeftArrow = []; //所有向左箭头的环节编号
            let stepRightArrow = []; //所有向右箭头的环节编号

            for (let i = 0; i < maxCount; i++) {
                let leftTemp = leftArrow.map(currentValue => currentValue + interval * i);
                let rightTemp = rightArrow.map(currentValue => currentValue + interval * i);

                stepLeftArrow = [...stepLeftArrow, ...leftTemp];
                stepRightArrow = [...stepRightArrow, ...rightTemp];

                evenRowFirstCol = [...evenRowFirstCol, evenRowFirstCol[i] + interval];
                evenRowLastCol = [...evenRowLastCol, evenRowLastCol[i] + interval];
            }

            for (let key in lcpzData) {
                let lcdyVO = lcpzData[key].lcdyVO; //流程定义信息
                let lchjVOs = lcpzData[key].lchjVOs; //流程环节信息
                let lcid = lcdyVO.pkid; //流程ID

                let lchjs = []; //流程环节
                if (lchjVOs !== null && lchjVOs != null) {

                    for (let index = 0; index < lchjVOs.length; index++) {
                        let lchjVO = lchjVOs[index];
                        let { pkid, hjid, bz, hjdm, hjmc, hjlb, zt, czqx } = lchjVO;

                        //根据图片名字，及操作权限加载相应环节图片
                        let hjtp;
                        if (zt == '1') {
                            hjtp = imgArray.filter(
                                img => img.name.indexOf(lchjVO.hjtp) != -1)[0];
                            if (!hjtp) {
                                hjtp = imgArray.filter(
                                    img => img.name.indexOf('通用01') != -1)[0];
                            }
                        } else {
                            hjtp = imgArray_grey.filter(
                                img => img.name.indexOf(lchjVO.hjtp) != -1)[0];
                            if (!hjtp) {
                                hjtp = imgArray_grey.filter(
                                    img => img.name.indexOf('通用01') != -1)[0];
                            }
                        }

                        //偏移栅格数
                        let offs = 0;
                        let offsParams = {};


                        //如果有后续环节且不换行，则根据算法添加向左指示箭头
                        if (typeof (lchjVOs[index + 1]) != 'undefined') {

                            //如果是向左箭头
                            let leftTarget = stepLeftArrow.filter(value => value == (index + 1))[0];

                            if (leftTarget) {
                                offs = offset * (3 - (index + 1) % 3);
                                if (offs == 18) {
                                    offs -= 3;
                                    offsParams = { push: offs };
                                    lchjs.push(
                                        <Col span={3} push={offs} key={createUuid()}>
                                            <img src={step_left_arrow} />
                                        </Col>
                                    );
                                } else if (offs == 9) {
                                    offs -= 6;
                                    offsParams = { pull: offs };
                                    lchjs.push(
                                        <Col span={3} pull={offs} key={createUuid()}>
                                            <img src={step_left_arrow} />
                                        </Col>
                                    );
                                }
                            }

                        } else {
                            //如果没有后续环节且是偶数行的第一个步骤

                            if (evenRowFirstCol.filter(value => value == (index + 1))[0]) {
                                offsParams = { push: 18 };
                            }

                        }

                        //如果是偶数行的最后一个步骤
                        if (evenRowLastCol.filter(value => value == (index + 1))[0]) {
                            offsParams = { pull: 18 };
                        }

                        let col = (
                            <Col span={6} {...offsParams} key={createUuid()}>
                                {
                                    //除了第一行，如果是奇数行的第一个步骤，则添加指向当前步骤的向下指示箭头
                                    index != 0 && evenRowLastCol.filter(value => value == index)[0] ?
                                        <img src={step_down_arrow} style={{ marginTop: 0 }} />
                                        : null
                                }
                                {
                                    //除了第一行，奇数行的后两个步骤需要校正位置
                                    evenRowLastCol.filter(value => value == index - 1)[0]
                                        || evenRowLastCol.filter(value => value == index - 2)[0] ?
                                        <div style={{ height: 58 }}></div>
                                        : null
                                }
                                <div className={styles.process_box}>
                                    <img src={hjtp ? hjtp.data : null} width={94} height={94} />
                                    <div>
                                        <span className={styles.no} style={{ backgroundColor: '#F8D44C' }}>{bz}</span>
                                        <span className={styles.title}>{hjmc}</span>
                                        <p className={styles.tip}>{hjlb == '1' ? '（必须办理）' : '（可选办理）'}</p>
                                        {czqx == '1' && zt == '1' ?
                                            <Link to={this.getStepLink(hjdm, hjid, pkid, index)}>
                                                <Button type="primary" className={styles.btn}>办理</Button>
                                            </Link>
                                            : zt == '0' ?
                                                <Button type="primary" disabled className={styles.btn}>已停用</Button>
                                                : <Button type="primary" disabled className={styles.btn}>无权限</Button>
                                        }
                                    </div>
                                </div>
                                {
                                    //如果是奇数行的最后一个步骤，且有下一步骤，则添加指向下一步骤的向下指示箭头
                                    typeof (lchjVOs[index + 1]) != 'undefined'
                                        && (index + 1) % 3 == 0
                                        && ((index + 1) / 3) % 2 != 0 ?
                                        <img src={step_down_arrow} style={{ marginTop: 0 }} />
                                        : null
                                }
                            </Col>
                        )

                        lchjs.push(col);

                        //如果有后续环节且不换行，则根据算法添加向右指示箭头
                        if (typeof (lchjVOs[index + 1]) != 'undefined') {

                            let rightTarget = stepRightArrow.filter(value => value == (index + 1))[0];

                            if (rightTarget) {
                                //如果是向右箭头
                                lchjs.push(
                                    <Col span={3} key={createUuid()}>
                                        {
                                            //校正指向箭头位置
                                            evenRowLastCol.filter(value => value == index)[0]
                                                || evenRowLastCol.filter(value => value == index - 1)[0] ?
                                                <div style={{ height: 58 }}></div>
                                                : null
                                        }
                                        <img src={step_right_arrow} />
                                    </Col>
                                );

                            }
                        }
                    }
                }

                let tabPane = (
                    <TabPane tab={lcdyVO.lcmc} key={lcid}>
                        {
                            getSize().windowW >= 1200 ?
                                <Scrollbars autoHide autoHeight autoHeightMax={getSize().windowH - 283} style={{ width: '100%' }}>
                                    <div style={{ padding: '0 20px 20px', textAlign: 'center' }}>
                                        <Row align="middle">
                                            {[...lchjs]}
                                        </Row>
                                    </div>
                                </Scrollbars>
                                :
                                <div style={{ padding: '0 20px 20px', textAlign: 'center' }}>
                                    <Row align="middle">
                                        {[...lchjs]}
                                    </Row>
                                </div>
                        }
                    </TabPane>
                );
                tabPanes.push(tabPane);
            }
        } else {
            tabPanes.push(
                <TabPane tab={''} key="0">
                    <div style={{ padding: '0 20px 20px', textAlign: 'center' }}>
                        <Row>
                            <Col>
                            </Col>
                        </Row>
                    </div>
                </TabPane>
            );
        }

        return tabPanes;

    }

    //获取环节页面链接
    getStepLink = (hjdm, hjid, lchjid, currentStep) => {
        let searchParams = encodeURIComponent(`key=${currentStep}&lcid=${this.state.lcid}&hjid=${hjid}&lchjid=${lchjid}`);
        switch (hjdm) {
            case 'GD001':
                return { pathname: '/yxxc/step/lstd', search: searchParams };
            case 'GD002':
                return { pathname: '/yxxc/step/jfbl', search: searchParams };
            case 'GD003':
                return { pathname: '/yxxc/step/ssfp', search: searchParams };
            case 'GD003_1':
                return { pathname: '/yxxc/step/ssfpFa', search: searchParams };
            case 'GD003_2':
                return { pathname: '/yxxc/step/ssfpFb', search: searchParams };
            case 'GD002_1':
                return { pathname: '/yxxc/step/jfblFxxy', search: searchParams };
            case 'GD002_2':
                return { pathname: '/yxxc/step/jfblFb', search: searchParams };
            case 'GD001_1':
                return { pathname: '/yxxc/step/szjdLstd', search: searchParams };
            case 'GD001_3':
                return { pathname: '/yxxc/step/ztxyLstd', search: searchParams };
            case 'GD007_1':
                return { pathname: '/yxxc/step/jxfzcmxx', search: searchParams };
            case 'GD001_2':
                return { pathname: '/yxxc/step/jhyszyLstd', search: searchParams };
            case 'GD001_4':
                return { pathname: '/yxxc/step/yntzyLstd', search: searchParams };
            case 'GD001_5':
                return { pathname: '/yxxc/step/ahgsLstd', search: searchParams };
            default:
                return { pathname: '/yxxc/step', search: searchParams };
        }
    }

    //面板切换回调
    handleTabPaneChange = (activeKey) => {

        this.loadPieStatisticalData(activeKey);
        this.loadTableStatisticalData(activeKey);
        this.setState({ lcid: activeKey });

        //切换流程后，将当前流程ID传递给父组件
        const onLoad = this.props.onLoad;
        if (onLoad) {
            let dqlcpz = this.state.lcpzData.filter(item => item.lcdyVO.pkid == activeKey)[0];
            onLoad(activeKey, dqlcpz, this.state.lcpzData);
        }
    }

    render() {

        const { lcid, defaultTab, loading } = this.state;
        const tabPanes = this.getTabPanes();

        let rowStyle = {};
        let echartsStyle = { height: 300 };
        let cardStyle = { marginBottom: 16 };

        if (getSize().windowW >= 1200) {
            rowStyle = { height: getSize().windowH - 206 };
            echartsStyle = { height: (getSize().windowH - 222) / 2 - 52 };
            cardStyle = { height: (getSize().windowH - 222) / 2 };
        }

        return (
            <div className={styles.process_content}>
                <Row gutter={24} style={rowStyle}>
                    <Col xl={7} lg={24} md={24} sm={24} xs={24} style={{ height: '100%' }}>
                        <Card
                            style={{ marginBottom: 16 }}
                            title="报到统计"
                            bodyStyle={{ padding: 0, textAlign: 'center' }}
                            bordered={false}>
                            <ReactEcharts
                                ref={e => this.echartCore = e}
                                style={echartsStyle}
                                option={this.getGaugeOption()}
                            />
                            <canvas id="myCanvas" style={{ display: 'none' }}></canvas>
                            <img id="gradient-color" src={jianbian} style={{ display: 'none' }} />
                        </Card>
                        <Card
                            style={cardStyle}
                            title="即时统计"
                            bodyStyle={{ textAlign: 'center', padding: 0, marginTop: 1 }}
                            bordered={false}>
                            {
                                getSize().windowW >= 1200 ?
                                    <Scrollbars autoHide autoHeight autoHeightMax={(getSize().windowH - 221) / 2 - 52} style={{ width: '100%' }}>
                                        {this.getTable()}
                                    </Scrollbars>
                                    : this.getTable()
                            }
                        </Card>
                    </Col>
                    <Col xl={17} lg={24} md={24} sm={24} xs={24} style={{ height: '100%' }}>
                        <div className={styles.process_card} style={{ height: '100%' }}>
                            <Spin spinning={loading}>
                                <Tabs size="large" tabBarStyle={{ marginBottom: 24 }} defaultActiveKey={defaultTab}
                                    activeKey={lcid} onChange={this.handleTabPaneChange}>
                                    {tabPanes}
                                </Tabs>
                            </Spin>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

Process.propTypes = {
    onLoad: PropTypes.func //流程配置加载完成回调
}


// WEBPACK FOOTER //
// ./components/yxxc/process.js